<template>
  <ul class="nav nav-mobile-menu">
    <!-- <li>
      <md-field>
        <label>Search</label>
        <md-input v-model="search" type="text"></md-input>
      </md-field>
    </li>--> 
    <li>
      <a @click="logout" class="dropdown-toggle" data-toggle="dropdown">
        <i class="material-icons">logout</i>
        <p>Logout</p></a>
    </li>
    <!-- <li>
      <a href="#" data-toggle="dropdown" class="dropdown-toggle"
        ><i class="material-icons">person</i>
        <p>Profile</p></a
      >
    </li> -->
  </ul>
</template>
<script>
import router from "@/routes"
export default {
  data() {
    return {
      search: null,
      selectedEmployee: null,
      employees: [
        "Jim Halpert",
        "Dwight Schrute",
        "Michael Scott",
        "Pam Beesly",
        "Angela Martin",
        "Kelly Kapoor",
        "Ryan Howard",
        "Kevin Malone"
      ]
    };
  },
  methods:{
    logout () { 
       localStorage.removeItem('authToken')
      router.push('/login')
      //  router.push('/login')

      }, 
  }
};
</script>
